var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isUpdating)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":24}}):_c('v-checkbox',{nativeOn:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleChange.apply(null, arguments)}},model:{value:(_vm.qc),callback:function ($$v) {_vm.qc=$$v},expression:"qc"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }